import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosConfig from "../../api/axiosConfig";

const AdminLogoutPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      // Sunucudaki /admin/logout'a istek atıyoruz
      axiosConfig
        .post("/admin/logout", null, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          console.log("Logout success from server.");
        })
        .catch((err) => {
          console.error("Logout error:", err);
        });
    }
 
    localStorage.removeItem("token");
    localStorage.removeItem("adminId");
    localStorage.removeItem("adminRole"); 

    navigate("/admin/login");
  }, [navigate]);

  return (
    <div className="p-4">
      Çıkış yapılıyor, lütfen bekleyin...
    </div>
  );
};

export default AdminLogoutPage;
